import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseService } from '../../_shared/base.service';
import { Merchant } from '../../_models/fundraising/Merchant';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';
import { LinkableAccount } from '../../_models/fundraising/LinkableAccount';

@Injectable()
export class MerchantService {

  public apiUrl = getUrl();

  constructor(
    private http: HttpClient,
    private jwtTokenService: JWTTokenService) { }


    public getAll(): Observable<Merchant[]> {
        return this.http.get<Merchant[]>(getUrl('merchant'), this.requestOptionsAuthenticated('portal'));
    }

    public getLinkableMerchants(): Observable<LinkableAccount[]> {
      return this.http.get<LinkableAccount[]>(getUrl('merchant/linkable'), this.requestOptionsAuthenticated('portal'));
    }

    public getLinkedVendors(merchantId: number): Observable<LinkableAccount[]> {
      return this.http.get<LinkableAccount[]>(getUrl('merchant/linked-vendors/' + merchantId), this.requestOptionsAuthenticated('portal'));
    }

    public getById(merchantId: number): Observable<Merchant> {
        return this.http.get<Merchant>(getUrl('merchant/' + merchantId), this.requestOptionsAuthenticated('portal'));
    }

    public create(merchantData): Observable<any> {
      return this.http.post<any>(getUrl('merchant/create'), merchantData, this.requestOptionsAuthenticated('portal'));
    }

    public updateLinkedVendors(accountId: number, linkedAccounts: LinkableAccount[]): Observable<any> {
      const merchantData = { accountId, linkedAccounts };
      return this.http.post<any>(getUrl('merchant/update-linked-vendors'), merchantData, this.requestOptionsAuthenticated('portal'));
    }

    public delete(merchantId: number): Observable<any> {
      return this.http.get<any>(getUrl('merchant/delete/' + merchantId), this.requestOptionsAuthenticated('portal'));
  }

    public update(merchantData): Observable<any> {
      return this.http.post<any>(getUrl('merchant/update'), merchantData, this.requestOptionsAuthenticated('portal'));
    }

    public resendPortalOnboardingUrl(merchantId: number): Observable<any> {
      return this.http.get<any>(getUrl('merchant/resend-invite/' + merchantId), this.requestOptionsAuthenticated('portal'));
    }

    public login(email: string, password: string): Observable<any> {
      const loginData = { email, password };
      return this.http.post<any>(getUrl('merchant/login'), loginData);
    }

    loggedIn(): Observable<boolean> {
      return of(!this.jwtTokenService.isTokenExpired('merchant'));
    }  

    public logout() {
      this.jwtTokenService.clearToken('merchant');
      BaseService.GlobalClearCache();
    }

    public forgotPassword(email: string) {
      return this.http.get<any>(getUrl(`merchant/forgot-password/${email}`));
    }

    public register(email: string, password: string) {
      const merchantData = { email, password };
      return this.http.post<any>(getUrl('merchant/register'), merchantData, this.requestOptionsAuthenticated('onboarding'));
    }

    public resetPassword(email: string, password: string) {
      const merchantData = { email, password };
      return this.http.post<any>(getUrl('merchant/reset-password'), merchantData, this.requestOptionsAuthenticated('forgotPassword'));
    }

    public activate() {
      return this.http.get<any>(getUrl('merchant/activate'), this.requestOptionsAuthenticated('stripe-onboarding'));
    }

    private requestOptionsAuthenticated(tokenKey: string) {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken(tokenKey)),
        };
        return requestOptions;
    }
}
